import { useParams } from "react-router-dom";

import SignUpPrompt from "../../components/SignUpPrompt";
import Header from "../Profile/components/Header";
import ViewJob from "../StaticPages/HomePage/components/ViewJob";

function SpecificJobDetails() {
	const { id } = useParams();
	return (
		<div className="min-h-screen">
			<Header />
			{/* The only place ViewJob renders as a full page rather than inside a drawer. */}
			{/* Keyed on the job: this route can now go job to job without unmounting, and ViewJob
			    holds per-job state (the explanation, its language, which sections are folded) that
			    would otherwise follow the reader onto the next posting. */}
			<ViewJob key={id} surface="job_details_page" />

			{/* Same anonymous-visitor upsell the home and company pages run. Direct links land a lot of
			    readers straight on a posting, so this is often the first Dproz page they see. */}
			<SignUpPrompt />
		</div>
	);
}

export default SpecificJobDetails;
